// extracted by mini-css-extract-plugin
module.exports = {"FilterWrapper":"TagFilter_FilterWrapper__2QPeJ","Filter":"TagFilter_Filter__1vx_X","FilterActive":"TagFilter_FilterActive__30EW5","FilterIcon":"TagFilter_FilterIcon__1nF2p"};